import { useEffect } from 'react';
import { Button } from '@/components/ui/atoms/Button';

const KICKER_SCRIPT_SRC = 'https://app.kicker.run/script.js';
const KICKER_FORM_ID = 'e91cc4b2-17f1-4082-adb1-99925527fe44';
const KICKER_ENDPOINT = `https://app.kicker.run/api/leads/${KICKER_FORM_ID}`;

const sentEmails = new Set<string>();

const isProd = (): boolean =>
  import.meta.env.VITE_API_SERVER_URL === 'https://backend.invirtus.co';

export const submitKickerLead = (
  email: string,
  extra: { name?: string; source?: string } = {},
): void => {
  if (!isProd()) return;
  if (!email || sentEmails.has(email)) return;
  sentEmails.add(email);

  try {
    fetch(KICKER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        email,
        name: extra.name ?? '',
        source: extra.source ?? (typeof window !== 'undefined' ? window.location.href : ''),
        metadata: {
          referrer: typeof document !== 'undefined' ? document.referrer : '',
        },
      }),
    }).catch(() => {
      // Lead capture is best-effort — never block signup on a failure.
    });
  } catch {
    // ignore
  }
};

export const KickerCapture = () => {
  useEffect(() => {
    if (!isProd()) return;
    if (document.querySelector(`script[src="${KICKER_SCRIPT_SRC}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = KICKER_SCRIPT_SRC;
    document.body.appendChild(script);
  }, []);

  if (!isProd()) return null;

  return (
    <form data-kicker-capture={KICKER_FORM_ID} className="hidden">
      <input type="text" name="name" placeholder="Your name" />
      <input type="email" name="email" placeholder="Your email" required />
      <Button
        type="contained"
        intent="primary"
        htmlType="submit"
        label="Join the waitlist"
      />
    </form>
  );
};

export default KickerCapture;
